import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";

// Create a theme instance.
let theme = createTheme({
  palette: {
    primary: {
      main: "#36B0C9",
    },
    secondary: {
      main: "#36B0C9",
    },
  },
  typography: {
    body1: {
      fontWeight: 400,
      lineHeight: 1.8,
      padding: 0
    }
  },
  overrides: {
    MuiFormControl: {
      root: {
        minWidth: 120,
        margin: '0 8px 10px 0',
      },
    },
    MuiFormControlLabel: {
      root: {
        alignItems: "flex-start",
      },
      label: {
        fontWeight: "bold",
        margin: 0,
        fontSize: "14px"
      },
    },
    MuiInput: {
      input: {
        border: "1px solid #AFAFAF",
        borderRadius: "4px",
        height: "12px",
      },
    },
    MuiOutlinedInput: {
      root: {
        height: "28px",
      },
    },
  },
  props: {
    MuiButton: {
      color: "primary",
    },
    MuiTextField: {
      variant: "outlined",
      InputLabelProps: {
        shrink: true,
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
